<template src="./Index.html" />

<script>

import AppointmentView from './components/Appointment.vue';
import PaymentView from './components/Payment.vue';
import PersonalView from './components/Personal.vue';

export default {
  components: {
    AppointmentView,
    PaymentView,
    PersonalView,
  },
  created() {
  },
  data() {
    return {
      patientId: null,
      item: null,
      view: 1,
    };
  },
  methods: {
    appointmentView(id) {
      this.patientId = id;
      this.view = 2;
    },
    paymentView(item) {
      this.item = item;
      this.view = 3;
    },
    back() {
      this.view = 1;
      this.patientId = null;
      this.item = null;

    },
  },
};
</script>